import styled from 'styled-components';
import { white } from 'styles/Colors';

export const SelectListWrapper = styled.div`
  background: ${white};
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.12);
  padding: 14px 13px 12px 11px;
  border-radius: 4px;
`;

export const Arrow = styled.span`
  position: absolute;
  top: -10px;
  right: 10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  border-color: transparent transparent ${white} transparent;
  &.below {
    bottom: -10px;
    top: auto;
    border-width: 10px 10px 0 10px;
    border-color: ${white} transparent transparent transparent;
  }
`;
